import { faBroom } from '@fortawesome/pro-solid-svg-icons/faBroom';
import {
	Button,
	ButtonSize,
	FlexAlign,
	FlexGap,
	StackHorizontal,
	Tooltip,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React from 'react';

type SelectionBarType = {
	selectedIds: Array<any>;
	clearSelectionCallback: () => void;
	iconsOnly?: boolean;
	children?: any;
};

function SelectionBar(props: SelectionBarType) {
	const { isMedium } = useLayout();
	const { t } = useTranslation();

	if (props.selectedIds.length === 0) return null;

	return (
		<StackHorizontal gap={FlexGap.ExtraSmall} align={FlexAlign.Center}>
			{props.children}

			<Tooltip
				disabled={isMedium && !props.iconsOnly}
				content={t('actions.clearSelectionCount', { count: props.selectedIds.length })}
			>
				<Button
					title={t('actions.clearSelectionCount', { count: props.selectedIds.length })}
					icon={faBroom}
					iconOnly={props.iconsOnly}
					size={ButtonSize.Small}
					onClick={() => props.clearSelectionCallback()}
				/>
			</Tooltip>
		</StackHorizontal>
	);
}

export default SelectionBar;
